import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Removes properties with undefined values from an object.
 * This is needed when passing objects to functions with optional properties
 * when exactOptionalPropertyTypes is enabled in TypeScript.
 *
 * @example
 * // Instead of: { page: params?.page, limit: params?.pageSize }
 * // Use: stripUndefined({ page: params?.page, limit: params?.pageSize })
 */
export function stripUndefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
	const result: Partial<T> = {};
	for (const key in obj) {
		if (Object.hasOwn(obj, key) && obj[key] !== undefined) {
			result[key] = obj[key];
		}
	}
	return result;
}
